import axios from 'axios'

const resizeImage = (file, maxWidth, maxHeight) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    img.onload = () => {
      let width = img.width
      let height = img.height

      if (width > maxWidth) {
        height = Math.round((height * maxWidth) / width)
        width = maxWidth
      }

      if (height > maxHeight) {
        width = Math.round((width * maxHeight) / height)
        height = maxHeight
      }

      canvas.width = width
      canvas.height = height

      ctx.clearRect(0, 0, width, height)
      ctx.drawImage(img, 0, 0, width, height)

      canvas.toBlob(
        (resizedFile) => {
          resolve(resizedFile)
        },
        'image/jpeg',
        0.8
      )
    }

    img.onerror = (error) => {
      reject(error)
    }

    img.src = URL.createObjectURL(file)
  })
}

const upload = async (
  {
    valor,
    descricao,
    tipo,
    modalidade,
    destaque,
    local,
    dormitorios,
    au,
    garagem,
    fotos,
    descricaoCompleta,
    featureIds
  },
  setHost
) => {
  const formData = new FormData()
  const host = setHost || 'http://localhost:3001'
  formData.append('valor', valor)
  formData.append('descricao', descricao)
  formData.append('modalidade', modalidade)
  formData.append('tipo', tipo)
  formData.append('local', local)
  formData.append('dormitorios', dormitorios)
  formData.append('au', au)
  formData.append('garagem', garagem)
  formData.append('destaque', destaque || false)
  formData.append('descricaoCompleta', descricaoCompleta)
  formData.append('featureIds', JSON.stringify(featureIds || []))

  for (let i = 0; i < fotos.length; i++) {
    const file = fotos[i]
    const resizedFile = await resizeImage(file, 800, 600)
    formData.append('fotos', resizedFile, file.name)
  }
  // eslint-disable-next-line
  for (const pair of formData.entries()) {
    // eslint-disable-next-line
    console.log(`${pair[0]}: ${pair[1]}`);
  }
  await axios.post(`${host}/products`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const getProperties = async (queryString) => {
  const host = process.env.REACT_APP_API_URL || 'http://localhost:3001'
  const { data } = await axios({
    method: 'get',
    url: `${host}/products?${queryString}`
  })
  return data
}

const getPropertiesByCode = async (code) => {
  const host = process.env.REACT_APP_API_URL || 'http://localhost:3001'
  const { data } = await axios({
    method: 'get',
    url: `${host}/products/${code}`
  })
  return data
}

const login = async (email, password, setHost) => {
  const host = setHost || 'http://localhost:3001'
  const { data } = await axios({
    method: 'post',
    url: `${host}/user/login`,
    data: {
      email,
      password
    }
  })
  localStorage.setItem('user', JSON.stringify(data))
}

const register = async (username, email, password, setHost) => {
  const host = setHost || 'http://localhost:3001'
  const { data } = await axios({
    method: 'post',
    url: `${host}/user/register`,
    data: {
      username,
      password,
      email
    }
  })
  localStorage.setItem('user', JSON.stringify(data))
}

const remove = async (id, setHost) => {
  const host = setHost || 'http://localhost:3001'
  const data = await axios({
    method: 'delete',
    url: `${host}/products/${id}`,
    data: {
      id
    }
  })
  return data
}

const updateProduct = async ({ id }, data, setHost) => {
  const host = setHost || 'http://localhost:3001'
  try {
    const response = await axios.put(`${host}/products/${id}`, data)
    return response.data
  } catch (error) {
    throw new Error('Failed to update product')
  }
}

export {
  upload,
  getProperties,
  getPropertiesByCode,
  login,
  register,
  remove,
  updateProduct
}
